import { dispatch } from 'nike-re-framejs';
import { setAvailableSports } from 'nike-ui/src/components/market-statistics/reframe/h&s';
import { stats2Client } from 'nike-ui/src/common/axios/stats2Client';

export const initAvailableMarketStatsSports = db => {
    stats2Client.get('/configuration').then(data => dispatch(setAvailableSports(data)));
    return db;
};
